export const GuideSectionTypes = {
  JS: 'javascript',
  HTML: 'html',
};
